import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

export function initSwiperCarousel() {
    const carousels = document.querySelectorAll(".related-post-carousel");
	if (carousels.length) {
		carousels.forEach((el) => {
			const swiper = new Swiper(el, {
				modules: [
					Navigation,
					Pagination
				],
				slidesPerView: 1,
				loop: false,
				speed: 800,
				spaceBetween: 24,
				autoHeight: true, // Cards have height: 100% in CSS
				navigation: {
					nextEl: el.querySelector(".swiper-button-next"),
					prevEl: el.querySelector(".swiper-button-prev"),
				},
				pagination: {
					el: el.querySelector(".swiper-pagination"),
					clickable: true,
				},
				autoplay: false,
				breakpoints: {
					768: {
						slidesPerView: 2,
						spaceBetween: 24,
					},
					1024: { 
						slidesPerView: 3,
						spaceBetween: 24,
					},
					1280: {
						slidesPerView: 3,
						spaceBetween: 24,
					}
				},
			});
		});
	}

	const servicesCarousels = document.querySelectorAll(".service-related .flip-services-carousel__viewport");
	if (servicesCarousels.length) {
		servicesCarousels.forEach((el) => {
			const parent = el.closest('.flip-services-carousel');
			if (!parent) return;

			// Check if already initialized by block script
			if (el.swiper) return;

			new Swiper(el, {
				modules: [ Navigation ],
				slidesPerView: 1.07,
				spaceBetween: 16,
				breakpoints: {
					480: { spaceBetween: 20, slidesPerView: 2.1 },
					768: { spaceBetween: 24, slidesPerView: 2.6 },
					992: { spaceBetween: 24, slidesPerView: 3.2 },
					1280: { spaceBetween: 24, slidesPerView: 3.8 },
				},
				navigation: {
					nextEl: parent.querySelector( '.swiper-button-next' ),
					prevEl: parent.querySelector( '.swiper-button-prev' ),
				},
			});
		});
	}

	const solutionsCarousels = document.querySelectorAll(".solutions-related .flip-solutions-carousel__viewport");
	if (solutionsCarousels.length) {
		solutionsCarousels.forEach((el) => {
			const parent = el.closest('.flip-solutions-carousel');
			if (!parent) return;

			// Check if already initialized by block script
			if (el.swiper) return;

			new Swiper(el, {
				modules: [ Navigation ],
				slidesPerView: 1.08,
				spaceBetween: 16,
				breakpoints: {
					480: { spaceBetween: 20, slidesPerView: 1.4 },
					768: { spaceBetween: 24, slidesPerView: 1.6 },
					992: { spaceBetween: 24, slidesPerView: 1.8 },
					1280: { spaceBetween: 32, slidesPerView: 2 },
				},
				navigation: {
					nextEl: parent.querySelector( '.swiper-button-next' ),
					prevEl: parent.querySelector( '.swiper-button-prev' ),
				},
			});
		});
	}
}